export const borrowerTooltipText = (borrower) => {
    if (!borrower) {
        return '';
    }
    return (
        <div style={{ textAlign: 'left' }}>
            <b>{borrower.borrowerEntity}</b>
            <br />
            {borrower.phone && (
                <span>
                    Tel: {borrower.phone}
                    <br />
                </span>
            )}
            {borrower.email}
            {borrower.address && (
                <div>
                    {borrower.address.street1}
                    {borrower.address.street2 && <div>{borrower.address.street2}</div>}
                    {(borrower.address.city || borrower.address.state || borrower.address.zipCode) && (
                        <div>
                            {borrower.address.city}, {borrower.address.state} {borrower.address.zipCode}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};
